const ORIGINAL_RETURN_DATA_KEY = 'service-agent-original-return-data'

const isRecord = value => Boolean(value) && typeof value === 'object' && !Array.isArray(value)
let currentOriginalReturnData = null

/**
 * 保存业务 H5 初次收到的不透明 returnData；会话恢复标识只能按核身任务临时保存。
 */
export const saveOriginalReturnData = (storage, returnData) => {
  if (!storage || !isRecord(returnData)) return false
  const { resumeSessionId, ...persistentReturnData } = returnData
  const serializedReturnData = JSON.stringify(persistentReturnData)
  // 当前页面内存代表本次联登权威值；即使持久化失败，也不能回读上一个用户的旧对象。
  currentOriginalReturnData = { storage, serializedReturnData }
  try {
    storage.setItem(ORIGINAL_RETURN_DATA_KEY, serializedReturnData)
    return true
  } catch (error) {
    try {
      storage.removeItem(ORIGINAL_RETURN_DATA_KEY)
    } catch {
      // 存储整体不可用时仍由本次内存快照遮蔽旧值，避免继续读取历史身份。
    }
    return false
  }
}

/**
 * 清理退出前的完整上下文；内存墓碑会防止存储异常时回读旧身份。
 */
export const clearOriginalReturnData = storage => {
  if (!storage) {
    currentOriginalReturnData = null
    return false
  }
  currentOriginalReturnData = { storage, serializedReturnData: null }
  try {
    storage.removeItem(ORIGINAL_RETURN_DATA_KEY)
    return true
  } catch (error) {
    return false
  }
}

/**
 * 读取完整业务上下文；即使历史缓存被污染也不允许恢复标识进入长期 returnData。
 */
export const readOriginalReturnData = storage => {
  if (!storage) return {}
  // 同一页面优先使用本次联登内存快照，避免持久化异常时旧用户数据反向覆盖当前身份。
  if (currentOriginalReturnData && currentOriginalReturnData.storage === storage) {
    return currentOriginalReturnData.serializedReturnData
      ? JSON.parse(currentOriginalReturnData.serializedReturnData)
      : {}
  }
  try {
    const parsed = JSON.parse(storage.getItem(ORIGINAL_RETURN_DATA_KEY) || '{}')
    if (!isRecord(parsed)) return {}
    const { resumeSessionId, ...persistentReturnData } = parsed
    return persistentReturnData
  } catch (error) {
    storage.removeItem(ORIGINAL_RETURN_DATA_KEY)
    return {}
  }
}
